"use client";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";

export default function Nvideo({ data, immg, config }: any) {
    const [_path, setPPath] = useState<any>(null);

    const changepath = (immg: any, data: any) => {
        setPPath(immg?.url);
    }
    const youtubeurlset = async (immg: any) => {
        let _url: any = String(process.env.NEXT_PUBLIC_SERVER) + String(process.env.NEXT_PUBLIC_API_BASE) + 'youtube/' + immg?.name;
        let _fans: any = await fetch(_url).then((response) => response.json());
        if (_fans?.data) {
            let _youtube = "https://www.youtube.com/embed/" + _fans?.data;
            setPPath(_youtube)
        } else {

        }
    }
    useEffect(() => {
        if (!_path) {
            if (immg?.cropped?.length > 0) {
                if (immg?.cropped?.[0].identifier) {
                    setPPath(immg?.mimage?.domain + '/' + immg?.mimage?.storage + immg?.cropped?.[0].identifier);
                } else {
                    setPPath(immg?.url);
                }
            } else {
                setPPath(immg?.url);
            }
        }
        if (immg?.extension === "youtube") {
            youtubeurlset(immg);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [immg]);
    return (
        <div className="w-100">
            {
                immg?.mimetype.includes('video/') || immg?.mimetype.includes('audio/') ?
                    _path ? <>
                        <ReactPlayer
                            url={_path}
                            controls={true}
                            light={false}
                            pip={true}
                            onError={(e) => changepath(immg, data)}
                            width="100%"
                            height="100%"
                        />
                        <source src={_path} type={immg?.mimetype} />
                    </> : null
                    : null
            }
        </div>
    );
}; 